import Vue from "vue"
import App from "@/App.vue"
import router from "@/router"
import store from "@/store"  // 引入状态管理 store
import axios from "@/service/request"
import apiUrl from "@/service/requestMapping"
import md5 from "js-md5"
import moment from "moment"
import VueWechatTitle from "vue-wechat-title"
import Footer from "@/components/Footer"
import Header from "@/components/Header"
import BannerBg from "@/components/BannerBg"
import $ from "jquery"
import "@/assets/vender/Jquery"

import "@/assets/css/legaltech.css"
import "@/assets/css/font-awesome.min.css"
import "@/assets/css/animator.min.css"
import "@/assets/css/phone_top.css"
import "@/assets/css/home_style.css"
import "@/assets/css/fixed.css"
// import "@/assets/js/SmoothScroll.js"
import "@/assets/css/bootstrap-touch-slider.css"
import "owl.carousel/dist/assets/owl.carousel.css"
import "@/assets/css/owl.theme.default.min.css" 
import "owl.carousel"
import "animate.css"
import ElementUI from "element-ui"
// import "element-ui/lib/theme-chalk/index.css"
import "@/assets/css/theme/element/pagination.css"

Vue.prototype.$axios = axios
Vue.prototype.$apiUrl = apiUrl
Vue.prototype.$md5 = md5
Vue.prototype.$moment = moment
Vue.use(VueWechatTitle)
Vue.use(ElementUI)
Vue.component("Footer", Footer)
Vue.component("Header", Header)
Vue.component("BannerBg", BannerBg)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  $,
  render: h => h(App)
}).$mount('#app')
